/** @jsx jsx */
import React, { ReactElement } from 'react';
import { css, jsx } from '@emotion/react';
import { NonIdealState } from '@blueprintjs/core';



export function SimpleList({data, children, includeTotal=false}: {data: Array<{count: number, key: string}>, children: (d) => ReactElement, includeTotal: boolean}) {

	return  data ? (
		<div css={simpleTable} className={"flex-column flex-1"}>
			{
				data?.map(children)
			}
			{includeTotal ?
				<div>
					<div className='flex-1 bold-me'>TOTAL</div>
					<div>{data?.reduce((t, e) => t + e.count, 0)}</div>
				</div>
				: null}
		</div>
	) :
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description=""
		/>

}

const simpleTable = css`
	width: 100%;
	
	& > * {
		display: flex;
		align-items: center;
		padding: 10px 15px 10px 10px;
		flex: 1;

		&:nth-of-type(even) {
			background: #ebf4f7;
		}
		&:nth-of-type(odd) {
			background: #f9f9f9;
		}

	}
`;
